import { CurrencyPipe, formatDate } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { FeaturesBaseComponent } from "src/app/features-common/components/features-base.component";
import { ReportsService } from "src/app/features/consumer-report/reports.service";
import * as moment from "moment";
import { HttpParams } from "@angular/common/http";
import { AdminViewService } from "src/app/framework/services/admin-view.service";

@Component({
  selector: "app-transaction-history",
  templateUrl: "./transaction-history.component.html",
  styleUrls: ["./transaction-history.component.scss"],
  providers: [CurrencyPipe],
})
export class TransactionHistoryComponent
  extends FeaturesBaseComponent
  implements OnInit
{
  private allTransactionSummary;
  public retailerdata;
  private startDate;
  private endDate;
  public rowData;
  public columnDefs;

  transactionSummary: any;
  salesSummary: any;
  commissionSummary: any;
  dilyTransactionsCount: any;
  weeklyTransactionsCount: any;
  allTransactionsCount: any;
  gridApi: any;
  gridColumnApi: any;
  selectedRows: any;
  monthlySaleSummary: any;
  monthlyCommisionSummary: any;
  monthlyTransactionsCount: any;
  searchValue: any;
  minFromDate: Date;
  maxDate: Date = new Date();
  minToDate: Date;
  transactionStartDate: string;
  transactionEndDate: string;
  commissionSummaryData: any[];
  saleSummaryData: any[];
  promocodeSummary: any;
  fromCntrl = new FormControl();
  toCntrl = new FormControl();
  retailerUserName: any;
  retailerAccountNum: any;
  currentAmount: any;
  showCard: boolean = true;
  refundData: any;
  isButtonDisabled:boolean


  constructor(
    private reportService: ReportsService,
    private currencyPipe: CurrencyPipe,
    private adminViewServices:AdminViewService
  ) {
    super();
  }

  /* Map sales summary values */
  setSummaryValues(allTransactionSummary: any) {
    this.transactionSummary = allTransactionSummary.transactionSummary;
    this.dilyTransactionsCount = allTransactionSummary.dailyTransactionSummary;
    this.weeklyTransactionsCount =
      allTransactionSummary.weeklyTransactionSummary;
    this.monthlyTransactionsCount =
      allTransactionSummary.monthlyTransactionSummary;
    this.allTransactionsCount = allTransactionSummary.allTransactionSummary;
    this.salesSummary = allTransactionSummary.salesSummary;
    this.monthlySaleSummary = allTransactionSummary.monthlySalesSummary;
    this.commissionSummary = allTransactionSummary.commissionSummary;
    this.promocodeSummary = allTransactionSummary.promocodeSummary;
    this.monthlyCommisionSummary =
      allTransactionSummary.monthlyCommissionSummary;
    let _salesSummary: any =
      (this.salesSummary / this.monthlySaleSummary) * 100;
    this.saleSummaryData = [_salesSummary, 100 - _salesSummary];
    let _commissionSummary: any =
      (this.commissionSummary / this.monthlyCommisionSummary) * 100;
    this.commissionSummaryData = [_commissionSummary, 100 - _commissionSummary];
  }

  setRowData(rowData: any) {
    this.rowData = rowData;
  }

  /**
   * Get curretnt retailer details from the route params id
   */
  // getretailerDetails() {
  //   this.retailerId = this.activeRoute.snapshot.params.retailerId;
  //   this.transactionService.getSelectedRetailer(this.userId).subscribe(
  //     res => this.retailerdata = res['httpcode'] == 200 ? res['data'] : []);
  // }

  handleApprove(rowData) {
    if (rowData.amount < 0 || rowData.refundStatus?.toLowerCase() == "yes") {
      return;
    }
    //alert
    //;
    if (rowData.beneficiaryNumber && rowData.beneficiaryNumber) {
      let formData: any = {
        beneficiaryNumber: rowData.beneficiaryNumber,
        productType: rowData.productType,
        rechargeAmount: rowData.amount,
        requestId: rowData.requestId,
      };
      this.reportService.approvePinlessrefund(formData).subscribe((res) => {
        if (res["httpcode"] == 200) {
          this.toastrService.success(`Refund Successful!`, `Success`);
          let params: any = new HttpParams()
            .set("endDate", this.endDate)
            .set("startDate", this.startDate);
          this.reportService.getTransactionHistory(params).subscribe((res) => {
            let resData: any = res;
            if (resData.httpcode == 200) {
              resData = resData.data;
              this.setRowData(res["data"]);
            }
          });
        }
      });
    }
  }

  /* ----- On Export click -----*/
  exportData() {
    let header = this.columnDefs.map((columnDef) => {
      let headerName = columnDef.headerName;
      return headerName;
    });
    let params: any = {
      fileName: "Transactions-History.csv",
      //columnSeparator: ';',
      skipHeader: true,
      columnKeys: this.columnDefs
        .map((c) => c.field || c.colId)
        .filter((c) => !!c),
    };
    params.customHeader = header.join(params.columnSeparator);
    params.processCellCallback = (cellParams) => {
      //
      if (cellParams && cellParams.column.colId === "") {
        return ""; //apply your timestamp formatter
      } else if (
        cellParams &&
        cellParams.column.colId === "transactionDatetime"
      ) {
        return moment(cellParams.value).format("MM/DD/YYYY");
      } else if (cellParams && cellParams.column.colId === "createdDttm") {
        return moment(cellParams.value).format("hh:mm:ss:a");
      } else if (cellParams && cellParams.column.colId === "rechargeStatus") {
        return cellParams.value === "Successfull"
          ? "Success"
          : "Failed";
      } else if (
        (cellParams && cellParams.column.colId === "paymentAmount") ||
        cellParams.column.colId === "convenienceFee" ||
        cellParams.column.colId === "initialBalance" ||
        cellParams.column.colId === "endingBalance"
      ) {
        return this.currencyPipe.transform(cellParams.value);
      }
       else if (
        cellParams &&
        cellParams.column.colId === "beneficiaryNumber"
      ) {
        const formatted = `'${this.formatMobileNumber(cellParams.value)}'`;
        return formatted;
      } else return cellParams.value; // no formatting
    };
    this.gridApi.exportDataAsCsv(params);
  }

  /* ------ AG Grid Events ------*/
  /* On Grid Ready */
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  /* On Global Search input changes */
  quickSearch() {
    this.gridApi.setQuickFilter(this.searchValue);
  }
  /* On Row Selection Change */
  onSelectionChanged(e) {
    this.selectedRows = this.gridApi.getSelectedRows();
  }

  /* ----- End of AG Grid Events -----*/

  /*  ----- Calendar click events ----- */

  onClickMonth() {
    let date = new Date();
    let startOfMonth = moment().startOf("month").toDate(); // Using local time instead of UTC
    this.fromCntrl.setValue(startOfMonth);
    this.toCntrl.setValue(date);
    this.transactionStartDate = this.fromCntrl.value;
    this.transactionEndDate = this.toCntrl.value;
    this.getTransactionHistory();
    // this.changeToDate(e);
  }

  onClickYear() {
    let date = new Date();
    let startOfYear = moment().startOf("year").toDate(); // Using local time instead of UTC
    console.log(startOfYear);
    this.fromCntrl.setValue(startOfYear);
    this.toCntrl.setValue(date);
    this.transactionStartDate = this.fromCntrl.value;
    this.transactionEndDate = this.toCntrl.value;
    this.getTransactionHistory();
  }

  getTransactionHistory() {
    let from = formatDate(this.fromCntrl.value, "yyyy-MM-dd", "en");
    let to = formatDate(this.toCntrl.value, "yyyy-MM-dd", "en");
    let params: any = new HttpParams()
      .set("startDate", from)
      .set("endDate", to);
    this.reportService.getTransactionHistory(params).subscribe((res) => {
      if (res["httpcode"] == 200 && res["data"] != null) {
        this.setRowData(res["data"]);
        this.allTransactionSummary = res["data"];
        this.setSummaryValues(this.allTransactionSummary);
      }
    });
  }

  changeFromDate(e) {
    this.minToDate = e.value;
    this.transactionStartDate = formatDate(e.value, "yyyy-MM-dd", "en");
    this.transactionEndDate = formatDate(
      this.toCntrl.value,
      "yyyy-MM-dd",
      "en"
    );
    if (
      this.transactionStartDate != null &&
      this.transactionStartDate != undefined
    ) {
      let params: any = new HttpParams()
        .set("startDate", this.transactionStartDate)
        .set("endDate", this.transactionEndDate);
      this.reportService.getTransactionHistory(params).subscribe((res) => {
        if (res["httpcode"] == 200 && res["data"] != null) {
          this.setRowData(res["data"]);
          this.allTransactionSummary = res["data"];
          this.setSummaryValues(this.allTransactionSummary);
        }
      });
    }
  }

  refundBtnClick(params) {
    this.refundData = params.data;
    console.log(params);
    if (params.data.paymentType === "Credit Card") {
      this.creditCardRefund();
    } else if (params.data.paymentType === "Google Pay") {
      this.googlePayRefund();
    } else {
      this.paypalRefund();
    }
  }

  creditCardRefund() {
    let params = new HttpParams()
      .set("paymentAmount", this.refundData.paymentAmount)
      .set("transactionId", this.refundData.transactionId)
      .set("consumerId", this.refundData.consumerId);
    this.reportService.creditCardRefund(params).subscribe({
      next: (res) => {
        this.toastrService.success(`Refund Successful!`, `Success`);
        this.getTransactionHistory();
      },
    });
  }

  googlePayRefund() {
    let params = new HttpParams()
      .set("paymentIntentId", this.refundData.paymentToken)
      .set("refundAmount", this.refundData.paymentAmount);
    this.reportService.googlePayRefund(params).subscribe({
      next: (res) => {
        this.toastrService.success(`Refund Successful!`, `Success`);
        this.getTransactionHistory();
      },
    });
  }

  paypalRefund() {
    let params = new HttpParams()
      .set("amount", this.refundData.paymentAmount)
      .set("saleId", this.refundData.transactionId);
    this.reportService.paypalRefund(params).subscribe({
      next: (res) => {
        this.toastrService.success(`Refund Successful!`, `Success`);
        this.getTransactionHistory();
      },
    });
  }

  changeToDate(e) {
    this.transactionStartDate = formatDate(
      this.fromCntrl.value,
      "yyyy-MM-dd",
      "en"
    );
    this.transactionEndDate = formatDate(e.value, "yyyy-MM-dd", "en");
    if (
      this.transactionStartDate != null &&
      this.transactionStartDate != undefined
    ) {
      let params: any = new HttpParams()
        .set("endDate", this.transactionEndDate)
        .set("startDate", this.transactionStartDate);
      this.reportService.getTransactionHistory(params).subscribe((res) => {
        if (res["httpcode"] == 200 && res["data"] != null) {
          this.allTransactionSummary = res["data"];
          this.setSummaryValues(this.allTransactionSummary);
          this.setRowData(res["data"]);
        }
      });
    }
  }

  /*  ----- End of Calendar click events ----- */

  /*  Lifecycle methods */

  /* OnInit */
  ngOnInit(): void {
    const self = this;
    super.ngOnInit();

     this.adminViewServices.checkAdminVRole().subscribe((res) => {
      this.isButtonDisabled = res
    })

    this.fromCntrl.setValue(new Date());
    this.toCntrl.setValue(new Date());

    // this.getretailerDetails();
    this.getTransactionHistory();

    this.transactionStartDate = formatDate(
      this.fromCntrl.value,
      "yyyy-MM-dd",
      "en"
    );
    this.transactionEndDate = formatDate(
      this.toCntrl.value,
      "yyyy-MM-dd",
      "en"
    );

    this.columnDefs = [
      {
        field: "transactionDatetime",
        headerName: "Date",
        width: 150,
        sort: "desc",
        cellRenderer: (data) => {
          return moment(data.value).format("MM/DD/YYYY");
        },
      },
      {
        field: "createdDttm",
        headerName: "Time",
        width: 150,
        cellRenderer: (data) => {
          return moment(data.value).format("hh:mm:ss:a");
        },
      },
      {
        field: "paymentAmount",
        headerName: "Total Payment",
        width: 180,
        cellRenderer: (data) => {
          return this.currencyPipe.transform(data.value);
        },
      },
      {
        field: "convenienceFee",
        headerName: "Convenience Fee",
        width: 200,
        cellRenderer: (data) => {
          return this.currencyPipe.transform(data.value);
        },

      },
      {
        field: "beneficiaryNumber",
        headerName: "Beneficiary Number",
        width: 270,
      },
      { field: "carrier", headerName: "Carrier", width: 200 },
      { field: "codeGroup", headerName: "Product Code", width: 200 },
      { field: "paymentType", headerName: "Payment Type", width: 210 },
      {
        field: "paymentStatus",
        headerName: "Payment Confirmation",
        width: 200,
        cellClass: "text-center",
      },
      {
        field: "rechargeStatus",
        headerName: "Recharge Confirmation",
        width: 200,
        cellClass: "text-center",
        cellRenderer: (params) => { 
          return params.data.rechargeStatus === "Successfull"
            ? "Success"
            : "Failed";
        },
      },
      {
        field: "refundDate",
        headerName: "Refund Date",
        width: 270,
        cellRenderer: (data) => {
          return data.value
        },
      },
      {
        field: "refundTime",
        headerName: "Refund Time",
        width: 270,
        cellRenderer: (data) => {
          return data.value
        },
      },
      {
        field: "refundStatus",
        headerName: "Refund Status",
        width: 200,
        cellClass: "text-center",
        cellRenderer: (params) => {
          if (params.data.responseStatus !== "Successfull") {
            return params.data.refundStatus === "Refund_Success"
              ? "Success"
              : "Failed";
          } else {
            return "-";
          }
        },
      },
      {
        field: "Action",
        headerName: "Action",
        width: 200,
        cellRenderer: (params) => {
          if (params.data.refundStatus === "Refund_Failed") {
            return `<span class="rounded-pill bg-main text-white px-2 py-2 cur-point">Refund</span>`;
          }

          return params.value;
        },
        onCellClicked: function (params) {
          if (params.data.refundStatus === "Refund_Failed") {
            self.refundBtnClick(params);
          }
        },
      },
    ];
    this.rowData = [];
  }

  formatMobileNumber(params: any): string {
    const phoneNumber = params;
    if (!phoneNumber) {
      return "";
    }

    if (phoneNumber.startsWith("+1")) {
      return phoneNumber.substring(2);
    }

    // Format mobile number (e.g., (123) 456-7890)
    const formatted = phoneNumber.replace(/\D/g, "");
    return formatted;
  }

  /* OnDestroy */
  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
